import { render } from "./autoTransport.vue?vue&type=template&id=08fe18ac&scoped=true"
import script from "./autoTransport.vue?vue&type=script&lang=js"
export * from "./autoTransport.vue?vue&type=script&lang=js"

import "./autoTransport.vue?vue&type=style&index=0&id=08fe18ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08fe18ac"]])

export default __exports__